/** Ajustes de HTML/SEO y tipografía unificada en fichas de producto. */

export function normalizePrestaShopDescriptionHtml(html: string): string {
  return html
    .replace(/<h1(\s[^>]*)?>/gi, '<h3$1>')
    .replace(/<\/h1>/gi, '</h3>')
    .replace(/<h2(\s[^>]*)?>/gi, '<h3$1>')
    .replace(/<\/h2>/gi, '</h3>');
}

/** Contenedor del texto de cuerpo (descripción corta, sugerencias, pestañas) — escritorio */
export const productBodyTextWrapperClass =
  'text-global-1 font-tt-norms-regular font-normal text-base leading-[21px]';

/** Contenedor del texto de cuerpo — móvil */
export const productBodyTextWrapperClassMobile =
  'text-[#3D1C1A] font-tt-norms-regular font-normal text-sm leading-5';

const bodyProseBase =
  'prose prose-sm max-w-none font-tt-norms-regular text-base leading-[21px] text-[#3d1c1a] ' +
  'prose-p:font-tt-norms-regular prose-p:font-normal prose-p:text-base prose-p:leading-[21px] prose-p:text-[#3d1c1a] ' +
  'prose-li:font-tt-norms-regular prose-li:font-normal prose-li:text-base prose-li:leading-[21px] prose-li:text-[#3d1c1a] ' +
  'prose-strong:font-tt-norms-bold prose-strong:text-[#3d1c1a] prose-em:text-[#3d1c1a] ' +
  'prose-ul:text-[#3d1c1a] prose-ol:text-[#3d1c1a]';

const bodyProseBaseMobile =
  'prose prose-sm max-w-none font-tt-norms-regular text-sm leading-5 text-[#3d1c1a] ' +
  'prose-p:font-tt-norms-regular prose-p:font-normal prose-p:text-sm prose-p:leading-5 prose-p:text-[#3d1c1a] ' +
  'prose-li:font-tt-norms-regular prose-li:font-normal prose-li:text-sm prose-li:leading-5 prose-li:text-[#3d1c1a] ' +
  'prose-strong:font-tt-norms-bold prose-strong:text-[#3d1c1a] prose-em:text-[#3d1c1a] ' +
  'prose-ul:text-[#3d1c1a] prose-ol:text-[#3d1c1a]';

const h3InDescription =
  '[&_h3]:font-tt-norms-bold [&_h3]:text-lg [&_h3]:leading-6 [&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:text-[#3d1c1a]';

const h3InDescriptionMobile =
  '[&_h3]:font-tt-norms-bold [&_h3]:text-base [&_h3]:leading-5 [&_h3]:mt-3 [&_h3]:mb-2 [&_h3]:text-[#3d1c1a]';

/** Prosa para descripción corta, sugerencias e ingredientes */
export const productBodyProseClass = bodyProseBase;

export const productBodyProseClassMobile = bodyProseBaseMobile;

/** Prosa para descripción larga (incluye estilos de h3 del CMS) */
export const productDescriptionProseClass = `${bodyProseBase} ${h3InDescription}`;

export const productDescriptionProseClassMobile = `${bodyProseBaseMobile} ${h3InDescriptionMobile}`;

/** Alias: ingredientes e información nutricional en HTML */
export const productInfoProseClass = productBodyProseClass;

export const productInfoProseClassMobile = productBodyProseClassMobile;
